import React, { useEffect, useState } from "react";
import API, { CONFIG, UPDATE_CONFIG } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { Button } from "antd";
import ModalCommon from "../../components/Modal";
import RichTextEditor from "../../components/RichTextEditor";


const SetupRule = () => {
    const [configGame, setConfigGame] = useState();
    const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
    const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);

    const [rules, setRules] = useState('');
    const [term1, setTerm1] = useState('');
    const [term2, setTerm2] = useState('');

    useEffect(() => {
        getDataConfig();
    }, []);

    const getDataConfig = async () => {
        try {
            const res = await API.get(`${CONFIG}`);
            const data = res.data.data;
            setConfigGame({
                rules: data?.rules,
                term1: data?.term1,
                term2: data?.term2,
            });
            
            // Set initial values for editors
            setRules(data?.rules || '');
            setTerm1(data?.term1 || '');
            setTerm2(data?.term2 || '');
        } catch (err) {
            console.log(err);
        }
    };

    const handleChangeInput = (value, key) => {
        switch (key) {
            case 1: setRules(value || ""); return;
            case 2: setTerm1(value || ""); return;
            case 3: setTerm2(value || ""); return;
            default: return;
        }
    };

    const handleUpdateConfig = async () => {
        try {
            setIsShowModalConfirm(false);
            setIsShowModalSuccess(true);
            const body = {
                config: {
                    rules: rules,
                    term1: term1,
                    term2: term2,
                }
            };
            
            await API.patch(`${UPDATE_CONFIG}`, body);
        } catch (err) {
            console.log(err);
        }
    };

    const handleShowModal = () => {
        setIsShowModalConfirm(true);
    };

    const renderRichTextEditor = (key, defaultValue, changeInput, label, height = 200) => {
        const keyMap = {
            "rules": 1,
            "term1": 2,
            "term2": 3,
        };
        
        return (
            <div className="flex w-full items-start" style={{ marginBottom: "32px" }}>
                <div className="flex w-[20%] justify-end mr-10 pt-2">{label}:</div>
                <div className="w-[60%]">
                    <RichTextEditor 
                        value={defaultValue || ''} 
                        onChange={(value) => changeInput(value, keyMap[key])} 
                        placeholder={`Nhập ${String(label || '').toLowerCase()}...`}
                        height={height}
                    />
                </div>
            </div>
        )
    }


    return (
        <div className="col-12">
            {configGame && 
                <div className="col-12">
                    <div className="flex w-full">
                        <div className="flex flex-col w-full items-center justify-center">
                            <div className="col-10 mt-2 flex flex-col items-center justify-center">
                                {renderRichTextEditor(
                                    "rules",
                                    rules, 
                                    handleChangeInput, 
                                    "Luật chơi",
                                    250
                                )}

                                {renderRichTextEditor(
                                    "term1",
                                    term1, 
                                    handleChangeInput, 
                                    "Thể lệ 1",
                                    200
                                )}

                                {renderRichTextEditor(
                                    "term2",
                                    term2, 
                                    handleChangeInput, 
                                    "Thể lệ 2",
                                    200
                                )}
                            </div>
                            <div className="col-10 mt-5 flex items-center justify-center">
                                <Button type="primary" onClick={handleShowModal}>
                                    Cập nhật
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {isShowModalConfirm && (
                <ModalCommon
                    isShow={isShowModalConfirm}
                    message={TEXT_DEF.text0062}
                    txtBtnAcc={TEXT_DEF.text0008}
                    textBtnClose={TEXT_DEF.text0023}
                    actionNext={handleUpdateConfig}
                    close={() => setIsShowModalConfirm(false)}
                />
            )}
            {isShowModalSuccess && (
                <ModalCommon
                    isShow={isShowModalSuccess}
                    message={TEXT_DEF.text0063}
                    txtBtnAcc={TEXT_DEF.text0007}
                    actionNext={() => {
                        setIsShowModalSuccess(false);
                    }}
                    close={() => {
                        setIsShowModalSuccess(false);
                    }}
                />
            )}
        </div>
    );
};

export default SetupRule;
